export default {
    title: '變更申請'
}
